module.exports = __webpack_public_path__ + "static/pre-video-liquid-bac975b2d2b1b8eabe18323ab3d5975a.png";